<div id="details-container">
  <dl>
    @if (!!orderMetrics?.totalTime) {
    <dt>Total Time:</dt>
    <dd>{{ orderMetrics?.totalTime! }}ms</dd>
    } @if (!!orderMetrics?.search) {
    <dt>Search:</dt>
    <dd>{{ orderMetrics?.search! }}ms</dd>
    } @if (!!orderMetrics?.riskAssessment) {
    <dt>Risk Assessment:</dt>
    <dd>{{ orderMetrics?.riskAssessment! }}ms</dd>
    } @if (!!orderMetrics?.wcl) {
    <dt>WCL:</dt>
    <dd>{{ orderMetrics?.wcl! }}ms</dd>
    } @if (!!orderMetrics?.domain) {
    <dt>Domain:</dt>
    <dd>{{ orderMetrics?.domain! }}ms</dd>
    }
  </dl>
  @if (!!kibanaUrl) {
  <a [href]="kibanaUrl" target="_blank">Open Logs</a>
  }
</div>
